import * as React from 'react';
import { get } from 'lodash';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';
import { FormSection } from 'redux-form';

import {
  Input,
  InputField,
  Toggle,
  ToggleField,
  Date,
  DateField,
  AutoComplete,
  AutoCompleteField,
  RemoteAutoComplete,
  RemoteAutoCompleteField,
  Photo,
  PhotoField
} from '@components/form';

import { Person } from '@components/person';
import Address, { AddressField } from '@components/form/Address/Address';
import { sexEnum, stateEnum } from '@modules/dogs/_dogsEnums';

const View: React.SFC<any> = ({ change, maxYear }) => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col className="grid-system-margin" />
      </Row>
      <Row>
        <Col md={4} xl={2} className="with-right-divider">
          <Row>
            <Col md={12}>
              <h4>Fotografie</h4>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <PhotoField component={Photo} name="photo" />
            </Col>
          </Row>
        </Col>
        <Col md={4} xl={2} className="with-right-divider">
          <Row>
            <Col md={12}>
              <h4>Základní údaje</h4>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <InputField component={Input} name="name" label="Jméno" />
            </Col>
          </Row>
          {[
            { name: 'sex', label: 'Pohlaví', items: sexEnum },
            { name: 'state', label: 'Stav registrace', items: stateEnum }
          ].map(field => (
            <Row key={field.name}>
              <Col md={12}>
                <AutoCompleteField
                  component={AutoComplete}
                  {...field}
                  fullWidth={true}
                  labelFunction={o => get(o, 'name')}
                  valueFunction={o => get(o, 'id')}
                />
              </Col>
            </Row>
          ))}
          {[
            { name: 'breed', label: 'Plemeno', url: 'api/dg/breeds', labelProp: 'name' },
            { name: 'color', label: 'Barva', url: 'api/dg/colors', labelProp: 'name' }
          ].map(({ labelProp, ...props }) => (
            <Row key={props.name}>
              <Col md={12}>
                <RemoteAutoCompleteField
                  component={RemoteAutoComplete}
                  fullWidth={true}
                  labelFunction={o => get(o, labelProp)}
                  filterActive={true}
                  {...props}
                />
              </Col>
            </Row>
          ))}
          <Row>
            <Col md={12}>
              <h4>Majitel</h4>
            </Col>
          </Row>
          <FormSection name="owner">
            <Person form={'DogsGrid'} formName="owner." withPhone={true} />
          </FormSection>
          <AddressField component={Address} name={'owner.address'} columnStyle={true} />
        </Col>

        <Col md={4} xl={2} className="with-right-divider">
          <Row>
            <Col md={12}>
              <h4>Identifikace</h4>
            </Col>
          </Row>
          {[
            { name: 'chipNumber', label: 'Číslo čipu' },
            { name: 'chipNumberExternal', label: 'Číslo čipu - externí' },
            { name: 'tattoo', label: 'Číslo tetování' },
            { name: 'idNumber', label: 'Číslo známky' }
          ].map(field => (
            <Row key={field.name}>
              <Col md={12}>
                <InputField component={Input} {...field} />
              </Col>
            </Row>
          ))}
          <Row>
            <Col md={12}>
              <div style={{ marginTop: 15 }}>
                <ToggleField
                  component={Toggle}
                  name="idLost"
                  label="Známka ztracena"
                  labelPosition="right"
                  onToggle={(_, value) => {
                    change('idLost', value);
                  }}
                />
              </div>
            </Col>
          </Row>
        </Col>
        <Col md={8} xl={4} className="with-right-divider">
          <Row>
            <Col md={12}>
              <h4>Pokročilé informace</h4>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              {[
                { name: 'birthDate', label: 'Datum narození' },
                { name: 'vaccinationDate', label: 'Datum vakcinace' },
                { name: 'idDate', label: 'Datum vydání známky' },
                { name: 'tattooDate', label: 'Datum tetování' },
                { name: 'chipDate', label: 'Datum čipování' }
              ].map(field => (
                <Row key={field.name}>
                  <Col md={12}>
                    <DateField component={Date} {...field} />
                  </Col>
                </Row>
              ))}
            </Col>
            <Col md={6}>
              {[
                { name: 'externalId', label: 'Identifikátor v externím systému' },
                {
                  name: 'yearFee',
                  label: 'Rok zaplacení poplatku',
                  type: 'number',
                  min: 1900,
                  max: maxYear
                }
              ].map(field => (
                <Row key={field.name}>
                  <Col md={12}>
                    <InputField component={Input} {...field} />
                  </Col>
                </Row>
              ))}
            </Col>
          </Row>
        </Col>
        <Col md={12} xl={2}>
          <Row>
            <Col md={12}>
              <h4>Doplňující informace</h4>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <InputField
                component={Input}
                multiLine={true}
                name="note"
                label="Poznámka"
                style={{ maxHeight: '60vh' }}
                inputStyle={{ maxHeight: '60vh' }}
                textareaStyle={{ maxHeight: '56vh' }}
              />
            </Col>
          </Row>
          <Row>
            <Col className="grid-system-margin" />
          </Row>
        </Col>
      </Row>

      <Row>
        <Col className="grid-system-margin" />
      </Row>
    </Grid>

    <Divider />
  </div>
);

export const DogsFormBasic = View;



// WEBPACK FOOTER //
// ./src/modules/dogs/DogsFormBasic.tsx